import React, { useEffect, useState } from 'react';
import { translate } from '../Services/translation';
import PublishEvent from '../Containers/Tracking.container';
import inputDelay from '../Services/inputDelay';

const MIN_QUANTIY = 0;
const MAX_QUANTIY = 999;
const CART_MOBILE_HIDDEN_CLASS = 'cart__info--mobile-hidden';

const MiniCart = (props) => {
  const showInfo = props ? props.showInfo : false;
  const [removingRow, setRemovingRow] = useState({});
  const [timeoutVar, setTimeoutVar] = useState();
  const [editingQuantity, setEditingQuantity] = useState({});
  const [cartMobileHiddenClass, setCartMobileHiddenClass] = useState(
    showInfo ? '' : CART_MOBILE_HIDDEN_CLASS
  );

  useEffect(() => {
    if (showInfo) {
      setCartMobileHiddenClass('');
      clearTimeout(timeoutVar);
      document.body.classList.add('minicart--open');
      onListItemsInCart();
    } else {
      document.body.classList.remove('minicart--open');
      setTimeoutVar(
        setTimeout(() => {
          setCartMobileHiddenClass(CART_MOBILE_HIDDEN_CLASS);
        }, 300)
      );
    }
  }, [showInfo]);

  const onQuantityChange = (rowSystemId, quantity) => {
    setEditingQuantity({
      ...editingQuantity,
      [rowSystemId]: Math.abs(quantity), // The quantity should be a positive number
    });
  };

  const handleUpdateClick = ({ rowSystemId, quantity }, currentQuantity) => {
    const originalQuantity = editingQuantity[rowSystemId] || quantity;
    const currentQuantityNumber =
      currentQuantity != null ? Number(currentQuantity) : 0;
    if (currentQuantityNumber < 1 || currentQuantityNumber === originalQuantity) {
      return;
    }
    props
      .updateOrderRowQuantity(rowSystemId, currentQuantityNumber)
      .then(() => onQuantityChange(rowSystemId, undefined));
  };

  const onClickPlus = (order) => {
    const quantity = order.quantity;
    if (quantity + 1 < MAX_QUANTIY)
      handleUpdateClick(order, quantity + 1);
  };

  const onClickMinus = (order) => {
    const quantity = order.quantity;
    if (quantity - 1 > MIN_QUANTIY) {
      handleUpdateClick(order, quantity - 1);
    }
  };

  const togglePreventDefault = (event) => {
    props.toggle();
    event.preventDefault();
  };

  const onSelectItem = (rowSystemId) => {
    const overRow = props.orderRows.find(
      (row) => row.rowSystemId === rowSystemId
    );

    if (!window.dataLayer?.find(el => el['gtm.start'])) {
      document.location = overRow.url
    }

    PublishEvent({
      event: 'select_item',
      ecommerce: {
        items: [
          {
            item_name: overRow.name,
            item_id: overRow.articleNumber,
            item_list_name: 'Products in cart'
          },
        ],
      },
      eventCallback: function () {
        document.location = overRow.url;
      },
    });
  };

  const onListItemsInCart = () => {
    if (props.orderRows)
      PublishEvent({
        event: 'view_item_list',
        ecommerce: {
          currencyCode: '',
          items: props.orderRows.map((row, index) => ({
            item_name: row.name,
            item_id: row.articleNumber,
            item_list_name: 'Products in cart',
            index: index + 1,
          })),
        },
      });
  };

  const onDeleteFromCart = (rowSystemId) => {
    const overRow = props.orderRows.find(
      (row) => row.rowSystemId === rowSystemId
    );
    PublishEvent({
      event: 'remove_from_cart',
      ecommerce: {
        remove: {
          products: [
            {
              name: overRow.name,
              id: overRow.articleNumber,
            },
          ],
        },
      },
    });
  };

  const onDeleteRequest = (rowSystemId, showDeleteButton) => {
    onDeleteFromCart(rowSystemId);
    props.updateOrderRowQuantity(rowSystemId, 0).then(() => {
      setRemovingRow({
        ...removingRow,
        [rowSystemId]: showDeleteButton,
      });
    });
  };

  const handleUpdateClickDelayed = inputDelay(handleUpdateClick, 500);

  let cartInfo;
  if (props.orderRows && props.orderRows.length > 0) {
    cartInfo = (
      <div
        className={`cart__info ${cartMobileHiddenClass} ${
          !showInfo ? 'cart__info--hidden' : ''
        }`}
      >
        <div className="cart__info-title">
          <h2 className="cart__title">{translate('minicart.checkout')}</h2>
          <span
            className="cart__close-button"
            onClick={(e) => togglePreventDefault(e)}
          ></span>
        </div>
        <div className="cart__products-wrapper">
          {props.orderRows &&
            props.orderRows.map((order) => (
              <div className="cart__product-row" key={order.rowSystemId}>
                <div className="cart__product-row__image">
                  <img
                    className="cart__product-image"
                    src={order.image}
                    alt={order.name}
                  />
                </div>
                <div className="cart__product-row__info">
                  <a
                    className="cart__product-title"
                    onClick={() => onSelectItem(order.rowSystemId)}
                    href={order.url}
                  >
                    {order.name}
                  </a>
                  <div className="cart__product-qty-and-price">
                    <div className="cart__product__qty">
                      {order.isFreeGift ? (
                        <div>{order.quantity}</div>
                      ) : (
                        <div className="qtybox">
                          <button
                            className="qtybox__button-minus"
                            onClick={(_) => onClickMinus(order)}
                          >
                            −
                          </button>
                          <input
                            className="qtybox__input"
                            type="number"
                            min={1}
                            maxLength={3}
                            value={
                              editingQuantity[order.rowSystemId] || order.quantity
                            }
                            onChange={(event) => {
                              const value = event.target.value;
                              if (value) {
                                handleUpdateClickDelayed(order, value);
                              }
                            }}
                          />
                          <button
                            className="qtybox__button-plus"
                            onClick={(_) => onClickPlus(order)}
                          >
                            +
                          </button>
                        </div>
                      )}
                    </div>
                    <div className="cart__product-price">
                      {order.campaignPrice ? order.campaignPrice : order.price}
                    </div>
                  </div>
                </div>
                <div className="cart__product-block__actions">
                  {!order.isFreeGift && !removingRow[order.rowSystemId] && (
                    <a
                      className="cart__product-delete"
                      onClick={() => onDeleteRequest(order.rowSystemId, true)}
                      title={translate('general.remove')}
                    ></a>
                  )}
                </div>
              </div>
            ))}
        </div>
        <div className="cart__info-summary">
          <p className="cart__info-row">
            <span className="label">{translate('checkout.order.total')}</span>
            <span className="value">{props.orderTotal}</span>
          </p>
        </div>
        <a href={props.checkoutUrl} className="button cart__checkout-button">
          {translate('minicart.checkout')}
        </a>
      </div>
    );
  } else {
    cartInfo = (
      <div
        className={`cart__info ${cartMobileHiddenClass} ${
          !showInfo ? 'cart__info--hidden' : ''
        }`}
      >
        <div className="cart__info-title">
          <span
            className="cart__close-button"
            onClick={(e) => togglePreventDefault(e)}
          ></span>
        </div>
        <div className="cart__products-wrapper">
          <h3 className="cart__basket-is-empty">
            {translate('checkout.cart.empty')}
          </h3>
        </div>
      </div>
    );
  }

  return (
    <div className="cart cart--mini">
      <a
        href="#"
        className="cart__link--block"
        onClick={(e) => togglePreventDefault(e)}
      >
        <i className="cart__icon">
          {props.quantity > 0 && (
            <span className="cart__quantity">{props.quantity}</span>
          )}
        </i>
      </a>
      {cartInfo}
      <div
        className={`cart__info-backdrop ${
          !showInfo ? 'cart__info-backdrop--hidden' : ''
        }`}
        onClick={(e) => togglePreventDefault(e)}
      ></div>
    </div>
  );
};

export default MiniCart;
